import { ErrorPageLayout } from '@/components/features/Errors/ErrorPageLayout';
import { Button } from '@/components/ui/shadcn/button';
import { useTranslations } from '@/hooks/useTranslations';
import { Head } from '@inertiajs/react';
import { Construction, RotateCw } from 'lucide-react';

export default function Maintenance() {
    const { t } = useTranslations();

    return (
        <>
            <Head title={t('errors.maintenance.title', 'Under maintenance')} />
            <ErrorPageLayout
                icon={<Construction />}
                tone="info"
                code={t('errors.maintenance.code', '503')}
                title={t('errors.maintenance.title', 'Under maintenance')}
                description={t('errors.maintenance.description', "We're performing scheduled maintenance. Please check back shortly.")}
                actions={
                    <Button onClick={() => window.location.reload()}>
                        <RotateCw className="mr-2 h-4 w-4" />
                        {t('errors.maintenance.retry', 'Refresh')}
                    </Button>
                }
            />
        </>
    );
}
